// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '9e8f7b9375e1b6abf7e5d38e594e8e52a59d8760',
  short: '9e8f7b9',
  builtAt: '2026-10-26T07:20:44.832Z',
} as const;
